import { useEffect, useState } from "react";


export const useNavbarHook = () => {
    const [isBreadCrumbOpened, setIsBreadCrumbOpened] = useState(false);
    const handleNavAction = () => { // function to handle click on Nav items
        setIsBreadCrumbOpened(false);
    };
    const handleBreadCrumbToggle = (val?: boolean) => {
        setIsBreadCrumbOpened((isOpened) => val !== undefined ? val : !isOpened);
    }

    useEffect(() => {
        if (!isBreadCrumbOpened) {
            return;
        }
        const closeOnEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                setIsBreadCrumbOpened(false);
            }
        };
        window.addEventListener("keydown", closeOnEscape);
        return () => window.removeEventListener("keydown", closeOnEscape);
    }, [isBreadCrumbOpened]);

    return {isBreadCrumbOpened, handleNavAction, handleBreadCrumbToggle}
}
